module.exports = __webpack_public_path__ + "images/unboxing_videos/cover_timeline-1d57343ed2ad389fe1c63e0e87bbbcca.png";